import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity RolePermissions


export interface RolePermission {
    id: ID;

    
    roleId: ID;

    
    permission: string;

    
    createdAt: Date;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            roleId: ID[],
        
    
    

            permission?: string,
        
    
    



        roleIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateRolePermission {
    
    roleId: ID;

    
    permission: string;

    
    }



export interface PresentationRolePermissionRequest {
    list: ListRequest,
    filter: {
        roleId: ID,
        roleIdOr: boolean,
        permission: string,
        permissionOr: boolean,
        roleIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryRolePermission {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: RolePermission): PrimaryRolePermission | undefined {
        return entity ? new PrimaryRolePermission(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryRolePermission {
        return new PrimaryRolePermission(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryRolePermission {
        let vals = path?.split('/');
        return new PrimaryRolePermission(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryRolePermission[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: RolePermission): string {
    let fields = entity ? [
    entity.roleId,
            entity.permission,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


